import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import {
  faUserAstronaut,
  faRobot,
  faPaw,
  faLeaf,
  faSun,
  faHeart,
  faBasketball,
  faMusic,
  faMountain,
  faFish,
  faCar,
  faMugSaucer,
  faUser
} from '@fortawesome/free-solid-svg-icons';

export type AvatarKey =
  | 'astronaut'
  | 'robot'
  | 'paw'
  | 'leaf'
  | 'sun'
  | 'heart'
  | 'basketball'
  | 'music'
  | 'mountain'
  | 'fish'
  | 'car'
  | 'mug'
  | 'avatar1'
  | 'avatar2'
  | 'avatar3'
  | 'avatar4'
  | 'avatar5'
  | 'avatar6'
  | 'avatar7'
  | 'avatar8'
  | 'avatar9'
  | 'avatar10'
  | 'avatar11'
  | 'avatar12'
  | 'avatar13'
  | 'avatar14'
  | 'avatar15'
  | 'avatar16'
  | 'avatar17'
  | 'avatar18'
  | 'custom'; // Avatar personalizado

export interface AvatarTheme {
  key: AvatarKey;
  label: string;
  icon: IconDefinition;
  color: string;
  background: string;
  photoURL?: string; // URL de foto personalizada
}

const THEMES: AvatarTheme[] = [
  { key: 'astronaut', label: 'Astronauta', icon: faUserAstronaut, color: '#7DD3FC', background: 'rgba(125, 211, 252, 0.18)' },
  { key: 'robot', label: 'Robot', icon: faRobot, color: '#C084FC', background: 'rgba(192, 132, 252, 0.20)' },
  { key: 'paw', label: 'Huella', icon: faPaw, color: '#F97316', background: 'rgba(249, 115, 22, 0.18)' },
  { key: 'leaf', label: 'Hoja', icon: faLeaf, color: '#4ADE80', background: 'rgba(74, 222, 128, 0.18)' },
  { key: 'sun', label: 'Sol', icon: faSun, color: '#FACC15', background: 'rgba(250, 204, 21, 0.20)' },
  { key: 'heart', label: 'Corazon', icon: faHeart, color: '#F87171', background: 'rgba(248, 113, 113, 0.20)' },
  { key: 'basketball', label: 'Baloncesto', icon: faBasketball, color: '#FB923C', background: 'rgba(251, 146, 60, 0.18)' },
  { key: 'music', label: 'Musica', icon: faMusic, color: '#60A5FA', background: 'rgba(96, 165, 250, 0.18)' },
  { key: 'mountain', label: 'Montana', icon: faMountain, color: '#A78BFA', background: 'rgba(167, 139, 250, 0.20)' },
  { key: 'fish', label: 'Pez', icon: faFish, color: '#2DD4BF', background: 'rgba(45, 212, 191, 0.18)' },
  { key: 'car', label: 'Auto', icon: faCar, color: '#F472B6', background: 'rgba(244, 114, 182, 0.18)' },
  { key: 'mug', label: 'Taza', icon: faMugSaucer, color: '#FDE68A', background: 'rgba(253, 230, 138, 0.22)' }
];

const DEFAULT_THEME: AvatarTheme | null = null;

export function getAvatarThemes(): AvatarTheme[] {
  return THEMES;
}

// Ensure resolveAvatarTheme never returns null
export function resolveAvatarTheme(key: string | null | undefined, photoURL?: string | null): AvatarTheme {
  if (!key) {
    return THEMES[0]; // Default to the first theme
  }

  // Si es un avatar personalizado, crear tema especial
  if (key === 'custom' && photoURL) {
    return {
      key: 'custom',
      label: 'Avatar personalizado',
      icon: faUser,
      color: '#60A5FA',
      background: 'rgba(96, 165, 250, 0.18)',
      photoURL
    };
  }

  return THEMES.find(theme => theme.key === key) || THEMES[0]; // Default to the first theme
}

export function resolveAvatarIcon(key: string | null | undefined): IconDefinition {
  return resolveAvatarTheme(key).icon ?? faUser;
}

export function isCustomAvatar(key: string | null | undefined): boolean {
  return key === 'custom';
}

export { THEMES };
